import React from 'react';

const awardWinningCards = [
  {
    id: 1,
    number: '01',
    title: 'On Site SEO Services',
    desc: 'Our technical SEO specialists make sure that search engine crawlers can access and index every part of your website without any restrictions, helping to improve your overall search rankings. In addition, we optimize your site for mobile devices, keeping up with Google’s shift toward mobile-first indexing.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <circle cx="11.5" cy="14.5" r="2.5"></circle>
        <path d="m13.5 16.5 2 2"></path>
      </svg>
    )
  },
  {
    id: 2,
    number: '02',
    title: 'Off Site SEO Services',
    desc: 'We strictly follow White Hat SEO techniques for all your website’s off-page SEO efforts, including brand mentions, local listings, social media engagement, guest blogging, and quality link building. Our focus is on earning authentic backlinks from reputable, high-authority websites to boost your domain authority naturally and effectively.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="m18 2 4 4-12 12H6v-4L18 2z"></path>
        <path d="m14 6 4 4"></path>
        <path d="m2 22 5-5"></path>
        <path d="m7 17 3 3"></path>
      </svg>
    )
  },
  {
    id: 3,
    number: '03',
    title: 'Search Engine Optimization',
    desc: 'Experts Communications is among the leading SEO service providers in Pakistan, delivering complete on page SEO solutions. From in-depth SEO audits and competitor analysis to strategic campaign planning and content evaluations, we ensure your website is fully optimized for maximum visibility and performance.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path>
      </svg>
    )
  }
];

function AwardWinningSeoSection() {
  return (
    <section className="award-seo-section">
      <div className="container">
        {/* Section Header */}
        <div className="award-seo-header">
          <h2 className="award-seo-title">
            Award Winning <span className="seo-red-title">Professional SEO Services</span> In Pakistan
          </h2>
          <p className="award-seo-subtitle">
            Sign Up Now and Get Your Website Ranked Organically
          </p>
        </div>

        {/* 3 Black Feature Cards Grid */}
        <div className="award-seo-grid">
          {awardWinningCards.map((card) => (
            <div key={card.id} className="award-seo-card">
              <div className="award-seo-card-top">
                <span className="award-seo-number">{card.number}</span>
                <div className="award-seo-icon">{card.icon}</div>
              </div>

              <h3 className="award-seo-card-title">{card.title}</h3>

              <p className="award-seo-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AwardWinningSeoSection;
